<app-loading></app-loading>
<app-mobile-warning></app-mobile-warning>

<ng-container *ngIf="!showSplash">
    <app-header *ngIf="boothDataLoaded"></app-header>
    <app-modal></app-modal>
    <!-- <router-outlet></router-outlet> -->
    <app-room [boothToNavigate]="boothToNavigate"></app-room>
    <app-chat></app-chat>
    <app-footer></app-footer>
</ng-container>

<ng-container *ngIf="showSplash">
    <app-splash></app-splash>
</ng-container>